import { PANELS, PANEL_STORAGE_KEY } from "../../config/panels";

const state = {
  DODView: false,
  DODAppSettings: null,
  // Aktywny panel: MAIN_APP | DOD | POD. Init z sessionStorage (przetrwa odswiezenie strony).
  activePanel:
    window.sessionStorage.getItem(PANEL_STORAGE_KEY) || PANELS.MAIN_APP,
};
const mutations = {
  SET_DOD_VIEW(state, status) {
    state.DODView = status;
  },
  SET_DOD_APP_SETTINGS(state, settings) {
    state.DODAppSettings = settings;
  },
  SET_ACTIVE_PANEL(state, panel) {
    state.activePanel = panel;
  },
};
const getters = {
  getDODView: (state) => state.DODView,
  getPreviousRouteDOD: () => window.sessionStorage.getItem("dodLastRoute"),
  getDODAppSettings: (state) => state.DODAppSettings,
  getActivePanel: (state) => state.activePanel,
};

export default {
  state,
  mutations,
  getters,
};
